<template>
  <VDialog
    v-model="isVisible"
    :width="dialogWidth"
    :height="dialogHeight"
    :hide-overlay="hideOverlay"
    persistent
  >
    <VCard color="secondary">
      <PsReportHeader
        v-if="showReportHeader"
        :id="headerId"
        :ref="headerRef"
        :header-width="reportHeaderWidth"
        :align-icons="headerAlignIcons"
        :show-search-bar="headerShowSearchBar"
        :show-add-button="headerShowAddButton"
        :show-save-button="headerShowSaveButton"
        :show-refresh-button="headerShowRefreshButton"
        :show-close-button="headerShowCloseButton"
        :show-check-button="headerShowCheckButton"
        :show-excel-button="headerShowExcelButton"
        :show-upload-button="headerShowUploadButton"
        :header-title="headerTitle"
        @check-event="headerCheckEvent"
        @search-event="headerSearchEvent"
        @save-event="headerSaveEvent"
        @refresh-event="headerRefreshEvent"
        @close-event="headerCloseEvent"
        @excel-event="headerExcelEvent"
        @upload-event="headerUploadEvent"
      />
      <PsTable
        v-if="showTable"
        :id="tableId"
        ref="dialogTable"
        :data="tableData"
        :options="tableOptions"
        :filter-string="tableFilterString"
        class="table-striped psTableDialog"
        :class="hideColumnHeader ? 'noTableHeader' : ''"
      />
      <slot
        v-if="showHtml"
      />
    </VCard>
  </VDialog>
</template>
<script>
export default {
    name: "PsDialog",
    props: {
        headerAlignIcons: { type: String, required: true, default: "left" },
        showHtml: Boolean,
        dialogWidth: { 
            type: String,
            required: false,
            default: "" 
        },
        persistent: Boolean,
        dialogHeight: { 
            type: String,
            required: false,
            default: "" 
        },
        reportHeaderWidth: { 
            type: String,
            required: false,
            default: "" 
        },
        value: Boolean,
        hideColumnHeader: { type: Boolean, default: false },
        hideOverlay: { type: Boolean, default: false },
        showTable: { type: Boolean, default: true },
        showReportHeader: { type: Boolean, default: true },
        headerRef: {
            type: String,
            required: false,
            default: ""
        },
        headerId: {
            type: String,
            required: false,
            default: ""
        },
        headerTitle: {
            type: String,
            required: false,
            default: ""
        },
        headerShowSearchBar: {
            type: Boolean,
            required: false
        },
        headerShowAddButton: {
            type: Boolean,
            required: false
        },
        headerShowRefreshButton: {
            type: Boolean,
            required: false
        },
        headerShowSaveButton: {
            type: Boolean,
            required: false
        },
        headerShowCloseButton: {
            type: Boolean,
            required: false
        },
        headerShowCheckButton: {
            type: Boolean,
            required: false
        },
        headerShowExcelButton:{
            type: Boolean,
            require: false,
            default: false
        },
        headerShowUploadButton:{
            type: Boolean,
            require: false,
            default: false
        },
        headerSearchEvent: {
            type: Function,
            required: false,
            default: () => {}
        },
        headerSaveEvent: {
            type: Function,
            required: false,
            default: () => {}
        },
        headerRefreshEvent: {
            type: Function,
            required: false,
            default: () => {}
        },
        headerCloseEvent: {
            type: Function,
            required: false,
            default: () => {}
        },
        headerCheckEvent: {
            type: Function,
            required: false,
            default: () => {}
        },
        headerExcelEvent:{
            type: Function,
            required: false,
            default: () => {}
        },
        headerUploadEvent:{
            type: Function,
            required: false,
            default: () => {}
        },
        tableId: {
            type: String,
            required: false,
            default: ""
        },
        tableRef: {
            type: String,
            required: false,
            default: ""
        },
        tableData: {
            type: Array,
            required: false,
            default: () => []
        },
        tableOptions: {
            type: Object,
            required: false,
            default: () => {}
        },
        tableFilterString: {
            type: String,
            required: false,
            default: ""
        }
    },
    computed: {
        isVisible: {
            get () {
                if (this.value === false) {
                    if (!this.isMounted) return this.value;
                }
                return this.value;
            },
            set (value) {
                this.$emit("input", value);
            }
        }
    },
    methods: {
        drag() {
            var elem = $('.v-dialog--active')[0];
            $(elem).draggable({handle: '#filter', containment:"#container"});
        }
    },
    watch: {
    isVisible: function(value) {
      if(value === true) {
        this.$nextTick(function() {
            this.drag();
        });           
      }
    }
    },
    mounted () {
      
        this.drag();
    }
};
</script>
<style>
.psTableDialog .tabulator-cell:hover {
    background-color: #90afc4 !important;
}
</style>